export const ipStatus = {
  1: {
    className: "discussion",
    fill: "var(--system-yellow-warning, #AA1A5F)",
    text: "Discussion",
  },
  2: {
    className: "documentReview",
    fill: "var(--system-yellow-warning, #FC9403)",
    text: "Document Review",
  },
  3: {
    className: "prePlanningPhase",
    fill: "var(--Primary-Blueberry-700, #325899)",
    text: "Pre Planning Phase",
  },
  4: {
    className: "dataCollection",
    fill: "#3B81FE",
    text: "Data collection",
  },
  5: {
    className: "closed",
    fill: "#555555",
    text: "Closed",
  },
  default: {
    className: "noStatus",
    fill: "rgba(172, 12, 12, 0.777)",
    text: "No Status",
  },
};

export const getIpStatus = (text) => ipStatus[text] || ipStatus.default;
